import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import bankData from '../../data/bankData';
import '../../assets/scss/Wallet/supportBank.scss';

class SupportBank extends Component {
  render () {
    return (
      <div>
        <Helmet><title>支持银行卡</title></Helmet>
        <div className='supportBank'>
          <div className='tip'>以下为热门支持银行，最终支持银行以银联认证为准。</div>
          <ul>
            {
              bankData.map((item, index) => {
                return (
                  <li key={index}>
                    <img src={require(`../../assets/images/bankIco/bank_ico_${item.code}@2x.png`).default} alt='' />
                    <div>{item.name}</div>
                  </li>
                )
              })
            }
          </ul>
        </div>
      </div>
    )
  }
}

export default SupportBank;